module.exports = __webpack_public_path__ + "feedback.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback.png
// module id = 184
// module chunks = 0